import React from 'react'
// Ant Design
import { Flex, Typography } from 'antd'
// Config
import { getConfig } from '../../config'

const { Title } = Typography

export const Header = ({t}) => {
    return (
        <Flex align="center" style={{ width: "100%", height: "60px", borderBottom: `2px solid ${getConfig("colorPrimario")}` }}>
            <Title level={3} style={{ marginBottom: "0" }}>{t("new_report")}</Title>
        </Flex>
    )
}